import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import { green } from '@mui/material/colors'
import React, { useEffect, useState } from 'react'
import '.././App.css';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Navigate, useNavigate } from 'react-router-dom'
import { Header } from '../Header/Header';
import { addParticipant } from './MainRequests';
import Swal from 'sweetalert2';
import DENR from '../assets/denr.png';
import PSA from '../assets/psa.png';
// media query
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
// import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export const Main = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const [message,setMessage] = useState('')
    // useEffect(() => {
    //     Pusher.logToConsole = true;

    //     // Initialize Pusher
    //     const pusher = new Pusher('3464ea0adaac89aeda6e', {
    //       cluster: 'ap1',
    //       forceTLS: true,
    //     });
    
    //     // Subscribe to the channel
    //     const channel = pusher.subscribe('channel-questions');
    //     // const channel = pusher.subscribe('new-channel');
    
    //     // Bind to an event
    //     channel.bind('event-questions', (data) => {
    //     //   setMessages((prevMessages) => [...prevMessages, data]);
    //       alert(data)
    //       console.log(data)
    //       setMessage(data)
    //     });
    
    //     // Cleanup on unmount
    //     return () => {
    //       channel.unbind_all();
    //       channel.unsubscribe();
    //     };
    //   }, []);
    // useEffect(()=>{
    //     window.Pusher = Pusher;

    //     const echo = new Echo({
    //         broadcaster: 'pusher',
    //         key: '3464ea0adaac89aeda6e',
    //         cluster: 'ap1',
    //         forceTLS: true,
    //     });

    //     // Subscribe to the channel
    //     echo.channel('channel-questions')
    //         .listen('event-questions', (data) => {
    //             console.log('Message received:', data.message);
    //         });
    // },[])
    const navigate = useNavigate()
    const [name,setName] = useState('')
    const [office,setOffice] = useState('')
    const [code,setCode] = useState('')
    useEffect(()=>{
        let n = localStorage.getItem('name');
        let o = localStorage.getItem('office');
        console.log(n)

        if(n){
            setName(n)
            setOffice(o)
            // return <Navigate to="/dashboard" replace />
        }
    },[])
    const handleProceed = async (e) => {
        e.preventDefault();
        
        try{
            const res = await addParticipant({name:name,code:code,office:office})
            if(res.data.status === 200){
                localStorage.setItem('name',name);
                localStorage.setItem('office',office);
                localStorage.setItem('user_id',res.data.data.id);
                localStorage.setItem('user_type',res.data.data.user_type);
                if(res.data.data.user_type === 1){
                    window.location.href = '/admin'
                }else{
                    window.location.href = '/dashboard'
                }
            }else{
                Swal.fire({
                    icon:'error',
                    title:res.data.message
                })
            }
        }catch(err){
            Swal.fire({
                icon:'error',
                title:err
            })
        }
        // navigate('/dashboard')
    }
    return (
        <Box id = 'main'>
            {/* <Header/> */}
            <form onSubmit={handleProceed}>
            <Box  sx={{display:'flex',flexDirection:'column',justifyContent:'center',gap:2,alignItems:'center',height:'100dvh'}}>
                <Grid container>
                <Grid item xs={12} sx={{display:'flex',justifyContent:'center',textAlign:'center'}}>
                    <Typography variant='h2' sx={{color:'#fff'}}>Statistics and Cybersecurity <br/>Quiz</Typography>
                </Grid>
                </Grid>
                <Grid container sx={{display:'flex',width:300,p:2,gap:1,background:'#fff',borderRadius:'10px'}}>
                    <Grid item xs={12}>
                        <TextField label = "Participant's Name" value={name} onChange={(e)=>setName(e.target.value.toUpperCase())} fullWidth required/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField label = "Office" value={office} onChange={(e)=>setOffice(e.target.value.toUpperCase())} fullWidth required/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField label = "Code" type='number' value={code} onChange={(e)=>setCode(e.target.value)} fullWidth required/>
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant='contained' fullWidth endIcon={<NavigateNextIcon/>} type='submit'>Proceed</Button>
                    </Grid>
                </Grid>
            </Box>
            </form>
            <Box sx={{position:'absolute',bottom:matches?10:30,left:'50%',transform:'translateX(-50%)'}}>
                <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                <img src={DENR} height='40px' width='40px'/>
                <img src={PSA} height='40px' width='55px'/>
                </Box>
            </Box>
        </Box>
    )
}